import { Component, Input } from '@angular/core';
var TagComponent = /** @class */ (function () {
    function TagComponent() {
    }
    TagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-tag',
                    template: "<a class=\"a-tag a-tag--small {{class}} {{ modifier && 'a-tag--' + modifier || modifier }} {{ icon && 'a-tag__icon-' + icon || icon }}\">\r\n\t{{text}}\r\n</a>\r\n"
                }] }
    ];
    TagComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }],
        class: [{ type: Input }],
        text: [{ type: Input }],
        id: [{ type: Input }],
        href: [{ type: Input }],
        icon: [{ type: Input }]
    };
    return TagComponent;
}());
export { TagComponent };
//# sourceMappingURL=tag.component.js.map